import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../../../shared/api'

export type NoteKind = 'tax' | 'health' | 'general'

export interface PersonNote {
  id: number
  personMainId: number
  kind: NoteKind
  text: string
  createdAt: string
  createdBy: string
}

export function usePersonNotes(personMainId: number | null) {
  return useQuery({
    queryKey: ['person-notes', personMainId],
    queryFn: () => api.get<PersonNote[]>(`/api/personen/${personMainId}/notes`),
    enabled: !!personMainId,
    staleTime: 30_000,
  })
}

export function useCreatePersonNote(personMainId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: { kind: NoteKind; text: string }) =>
      api.post<PersonNote>(`/api/personen/${personMainId}/notes`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['person-notes', personMainId] }),
  })
}

export function useDeletePersonNote(personMainId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => api.delete<{ id: number; archived: boolean }>(`/api/notes/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['person-notes', personMainId] }),
  })
}

export const NOTE_KIND_LABEL: Record<NoteKind, string> = {
  tax: 'Steuerbüro',
  health: 'Gesundheit',
  general: 'Allgemein',
}

export const NOTE_KIND_CLASS: Record<NoteKind, string> = {
  tax:     'bg-teal-50    text-teal-700    ring-teal-200',
  health:  'bg-rose-50    text-rose-700    ring-rose-200',
  general: 'bg-slate-100  text-slate-600   ring-slate-200',
}
